import {
	ExternalAgencyIdProperties,
} from '@app/models/api';

export default class PossibleMasterProducer {

	public displayName: string | null = null;
	public id: number | null = null;
	public externalAgencyIdProperties: ExternalAgencyIdProperties | null = null;

	public constructor() {
	}
};